import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { QRCodeModule } from 'angularx-qrcode';
import { LucideAngularModule, House, User, LogOut, CircleX, Calendar, X, Dot, Pencil, Save, KeyRound, Pin, ToggleRight, Barcode, FileText, Send, Trash, Eye, EyeOff, CreditCard, ShoppingCart, Monitor, Info, SquareCheckBig, Undo2, Settings, Plus, NotebookPen, Banknote, ChartSpline, Tag, Phone, MapPin, FileDigit, Hash, Wallet, WalletCards, HandCoins, ArrowUpFromLine, Import, Sigma, CircleAlert, CircleCheck, Menu, Search, Text, Smile, UserPlus, UserMinus, Coins, Landmark, Smartphone, ArrowDownToLine, Printer, RefreshCw, ShoppingBag, FilePenLine, CircleEllipsis, ChevronRight, ChevronLeft, ScanEye, Logs, HandCoinsIcon } from 'lucide-angular';
import * as echarts from 'echarts';
import { NgxEchartsModule } from 'ngx-echarts';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CircleAvatarComponent } from './components/circle-avatar/circle-avatar.component';
import { CustomCheckBoxComponent } from './components/custom/custom-check-box/custom-check-box.component';
import { CustomChipColoredComponent } from './components/custom/custom-chip-colored/custom-chip-colored.component';
import { CustomToggleComponent } from './components/custom/custom-toggle/custom-toggle.component';
import { DateSelectorComponent } from './components/date-selector/date-selector.component';
import { ExcelExportComponent } from './components/excel-export/excel-export.component';
import { InfoCardComponent } from './components/info-card/info-card.component';
import { LanguageSelectorComponent } from './components/language-selector/language-selector.component';
import { MultiselectTagsComponent } from './components/multiselect-tags/multiselect-tags.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { PrimaryButtonComponent } from './components/primary-button/primary-button.component';
import { PrintReportComponent } from './components/print-report/print-report.component';
import { ProfileMenuComponent } from './components/profile-menu/profile-menu.component';
import { TextButtonComponent } from './components/text-button/text-button.component';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { ActiveSecondaryLinksPipe } from './pipes/active-secondary-links.pipe';
import { RolesPermissionsCheckPipe } from './pipes/roles-permissions-check.pipe';
import { AngularMaterialModule } from '../angular-material/angular-material.module';
import { NgOtpInputModule } from 'ng-otp-input';
import { PermissionCheckPipe } from './pipes/permission-check.pipe';
import { RoleCheckPipe } from './pipes/role-check.pipe';
import { CategoriesDropdownComponent } from './components/categories-dropdown/categories-dropdown.component';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { UsersDropdownComponent } from './components/users-dropdown/users-dropdown.component';
import { UsersMultiselectDropdownComponent } from './components/users-multiselect-dropdown/users-multiselect-dropdown.component';
import { BillsMultiselectDropdownComponent } from './components/bills-multiselect-dropdown/bills-multiselect-dropdown.component';
import { CustomersDropdownComponent } from './components/customers-dropdown/customers-dropdown.component';
import { SearchFieldComponent } from './components/search-field/search-field.component';
import { CustomersMultiselectDropdownComponent } from './components/customers-multiselect-dropdown/customers-multiselect-dropdown.component';
import { GroupsMultiselectDropdownComponent } from './components/groups-multiselect-dropdown/groups-multiselect-dropdown.component';
import { ServicesDropdownComponent } from './components/services-dropdown/services-dropdown.component';
import { PosMultiselectDropdownComponent } from './components/pos-multiselect-dropdown/pos-multiselect-dropdown.component';
import { ProgressLoaderComponent } from './components/progress-loader/progress-loader.component';
import { ProductsDropdownComponent } from './components/products-dropdown/products-dropdown.component';
import { ActionButtonsComponent } from './components/action-buttons/action-buttons.component';
import { InvoicePaperBillComponent } from './components/invoice-paper-bill/invoice-paper-bill.component';
import { NgxBarcode6Module } from 'ngx-barcode6';
import { InvoicePaperComponent } from './components/invoice-paper/invoice-paper.component';
import { ProvidersDropdownComponent } from './components/providers-dropdown/providers-dropdown.component';
import { ArabicNumbersPipe } from './pipes/arabic-numbers.pipe';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { RouterModule } from '@angular/router';
import { CustomersChildsDetailsTableComponent } from './components/customers-childs-details-table/customers-childs-details-table.component';
import { TransLogTypeMultiselectDropdownComponent } from './components/trans-log-type-multiselect-dropdown/trans-log-type-multiselect-dropdown.component';
import { PrintFooterComponent } from './components/print-footer/print-footer.component';
import { ReportTransactionsTableComponent } from './components/tables/report-transactions-table/report-transactions-table.component';
import { ReportPurchaseTableComponent } from './components/tables/report-purchase-table/report-purchase-table.component';
import { WholesaleCustomersDropdownComponent } from './components/wholesale-customers-dropdown/wholesale-customers-dropdown.component';
import { EBillDetailsTableComponent } from './components/tables/e-bill-details-table/e-bill-details-table.component';
import { WholesaleBillsTableComponent } from './components/tables/wholesale-bills-table/wholesale-bills-table.component';
import { TypeOfPipe } from './pipes/type-of.pipe';
import { PrimeModule } from '../prime-module/prime.module';

@NgModule({
  declarations: [
    PrimaryButtonComponent,
    CircleAvatarComponent,
    InfoCardComponent,
    DateSelectorComponent,
    PaginatorComponent,
    ExcelExportComponent,
    TextButtonComponent,
    CustomCheckBoxComponent,
    RolesPermissionsCheckPipe,
    LanguageSelectorComponent,
    PrintReportComponent,
    ProfileMenuComponent,
    ClickOutsideDirective,
    MultiselectTagsComponent,
    CustomChipColoredComponent,
    ActiveSecondaryLinksPipe,
    CustomToggleComponent,
    PermissionCheckPipe,
    RoleCheckPipe,
    CategoriesDropdownComponent,
    UsersDropdownComponent,
    UsersMultiselectDropdownComponent,
    BillsMultiselectDropdownComponent,
    CustomersDropdownComponent,
    SearchFieldComponent,
    CustomersMultiselectDropdownComponent,
    GroupsMultiselectDropdownComponent,
    ServicesDropdownComponent,
    PosMultiselectDropdownComponent,
    ProgressLoaderComponent,
    ProductsDropdownComponent,
    ActionButtonsComponent,
    InvoicePaperBillComponent,
    InvoicePaperComponent,
    ProvidersDropdownComponent,
    ArabicNumbersPipe,
    BreadcrumbComponent,
    CustomersChildsDetailsTableComponent,
    TransLogTypeMultiselectDropdownComponent,
    PrintFooterComponent,
    ReportTransactionsTableComponent,
    ReportPurchaseTableComponent,
    WholesaleCustomersDropdownComponent,
    EBillDetailsTableComponent,
    WholesaleBillsTableComponent,
    TypeOfPipe,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    NgbModule,
    LucideAngularModule.pick({
      House,User,LogOut,Text,CircleX,
      Calendar,X,Dot,Pencil,Save,KeyRound,
      Pin,ToggleRight,Barcode,FileText,
      Send,Trash,Eye,EyeOff,CreditCard,
      ShoppingCart, Monitor, Info, SquareCheckBig, Undo2,
      Settings,Plus,NotebookPen,Banknote,ChartSpline, Tag,
      Phone, MapPin, FileDigit, Hash, Wallet, WalletCards,HandCoins, 
      ArrowUpFromLine, Import, Sigma, CircleAlert,CircleCheck,Menu,
      Search, Smile, UserPlus, UserMinus,Coins,Landmark, Smartphone,
      ArrowDownToLine,Printer, RefreshCw, ShoppingBag, FilePenLine,CircleEllipsis,
      ChevronRight,ChevronLeft, ScanEye, Logs, HandCoinsIcon
    }),
    NgxSpinnerModule,
    QRCodeModule,
    NgxEchartsModule.forRoot({ echarts }),
    NgOtpInputModule,
    PickerModule,
    NgxBarcode6Module,
    RouterModule,
    PrimeModule
  ],
  exports:[
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    PrimaryButtonComponent,
    AngularMaterialModule,
    CircleAvatarComponent,
    NgbModule,
    LucideAngularModule,
    NgxSpinnerModule,
    InfoCardComponent,
    DateSelectorComponent,
    PaginatorComponent,
    ExcelExportComponent,
    TextButtonComponent,
    CustomCheckBoxComponent,
    RolesPermissionsCheckPipe,
    PermissionCheckPipe,
    LanguageSelectorComponent,
    PrintReportComponent,
    QRCodeModule,
    ProfileMenuComponent,
    ClickOutsideDirective,
    MultiselectTagsComponent,
    CustomChipColoredComponent,
    NgxEchartsModule,
    ActiveSecondaryLinksPipe,
    CustomToggleComponent,
    NgOtpInputModule,
    RoleCheckPipe,
    CategoriesDropdownComponent,
    PickerModule,
    UsersDropdownComponent,
    UsersMultiselectDropdownComponent,
    BillsMultiselectDropdownComponent,
    CustomersDropdownComponent,
    SearchFieldComponent,
    CustomersMultiselectDropdownComponent,
    GroupsMultiselectDropdownComponent,
    ServicesDropdownComponent,
    PosMultiselectDropdownComponent,
    ProductsDropdownComponent,
    ActionButtonsComponent,
    InvoicePaperBillComponent,
    NgxBarcode6Module,
    InvoicePaperComponent,
    ProvidersDropdownComponent,
    ArabicNumbersPipe,
    BreadcrumbComponent,
    CustomersChildsDetailsTableComponent,
    TransLogTypeMultiselectDropdownComponent,
    PrintFooterComponent,
    ReportTransactionsTableComponent,
    ReportPurchaseTableComponent,
    WholesaleCustomersDropdownComponent,
    EBillDetailsTableComponent,
    WholesaleBillsTableComponent,
    TypeOfPipe,
    PrimeModule
  ],
  providers:[ActiveSecondaryLinksPipe,TypeOfPipe]
})
export class SharedModule { }
